var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 2.25V0L18 5.25l-5.25 5.25V8.25l3-3-3-3zM8.25 3V0l5.25 5.25-5.25 5.25V7.425c-3.75 0-6.375 1.2-8.25 3.825C.75 7.5 3 3.75 8.25 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrow);
export default __webpack_public_path__ + "static/media/share-arrow.ebc58ad2c549ef61ed531c6f35f891b6.svg";
export { ForwardRef as ReactComponent };